// Rutas del armador de cotizaciones (#1545). Viven aparte para que la tabla, la
// ficha del negocio y el armador las compartan sin arrastrarse entre sí.
export const QUOTES_PATH = "/crm/negocios/negocios/cotizaciones";

/** Editor de una cotización existente. */
export const quoteEditorPath = (id: string) => `${QUOTES_PATH}/${encodeURIComponent(id)}`;

/** Cotización nueva; desde un negocio o un lead hereda empresa, contacto y producto. */
export function newQuotePath({ dealId, leadId }: { dealId?: string | null; leadId?: string | null } = {}): string {
  const params = new URLSearchParams();
  if (dealId) params.set("dealId", dealId);
  if (leadId) params.set("leadId", leadId);
  const qs = params.toString();
  return `${QUOTES_PATH}/nueva${qs ? `?${qs}` : ""}`;
}
